import axios from 'axios'

export async function getLocationSettings(locationId) {
    if (!locationId) {
        return null
    }
    return axios
        .get(`${process.env.API_URL}/locations-settings/${locationId}`)
        .then(response => response.data)
        .catch(error => {
            if (error.response?.status === 404) {
                return null
            }
            throw error
        })
}

export async function createLocationSettings(payload) {
    return axios
        .post(`${process.env.API_URL}/locations-settings`, payload)
        .then(response => response.data)
}

export async function updateLocationSettings(locationId, data) {
    return axios
        .patch(`${process.env.API_URL}/locations-settings/${locationId}`, {
            data
        })
        .then(response => response.data)
}

export async function deleteLocationSettings(locationId) {
    return axios
        .delete(`${process.env.API_URL}/locations-settings/${locationId}`)
        .then(response => response.data)
}

export async function confirmLocationReplaceBait(locationId) {
    return axios
        .patch(
            `${process.env.API_URL}/locations/${locationId}/mass/confirm-replacement-of-bait`
        )
        .then(response => response.data)
}

export async function confirmLocationResetBaitThreshold(locationId) {
    return axios
        .patch(
            `${process.env.API_URL}/locations/${locationId}/mass/reset-bait-threshold`
        )
        .then(response => response.data)
}

export async function confirmLocationPowerOff(locationId) {
    return axios
        .patch(
            `${process.env.API_URL}/locations/${locationId}/mass/confirm-switch-off`
        )
        .then(response => response.data)
}

export async function confirmLocationMMModeOn(locationId, durationMinutes) {
    return axios
        .patch(
            `${process.env.API_URL}/locations/${locationId}/mass/maintenance-mode-on`,
            { duration_minutes: durationMinutes }
        )
        .then(response => response.data)
}

export async function confirmLocationMMModeOff(locationId) {
    return axios
        .patch(
            `${process.env.API_URL}/locations/${locationId}/mass/maintenance-mode-off`
        )
        .then(response => response.data)
}
